import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ManageSurvey from './ManageSurvey';
// import SurveyResultsTabSettings from './SurveyResultsTabSettings';
import SuveryResult from './SurveyResult';
import ViewSurveyResults from './ViewSurveyResults';
import ViewSurveyReports from './ViewSurveyReports';
import ErrorBoundary from '../../ErrorBoundary';
import SurveyMilestone from './SurveyMilestone';



class SurveyTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName"),
            patientAdmissionHeading: '',
        }
        window.surveyNavBarController = this;
    }
    componentDidMount() {

        this.paintPatientAdmissionHeading();
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/my-jeeva/projectmgmt/survey";
            var path1 = window.origin + "/my-jeeva/projectmgmt/survey/";
            if (currentPath == path || currentPath == path1) {
                $("#new-survey").addClass('active');
            } else if (currentPath.includes('/projectmgmt/survey/view-results') ||
                currentPath.includes('/projectmgmt/survey/view-results/')) {
                $("#view-results").addClass('active');
            } else if (currentPath.includes('/projectmgmt/survey/view-reports') ||
                currentPath.includes('/projectmgmt/survey/view-reports/')) {
                $("#view-reports").addClass('active');
            }
            else {
                $("#" + localStorage.getItem("last-project-survey-tab")).addClass('active')
            }
            $("#new-survey,#view-results", "#view-reports")
                .on("click", function () {
                    $("#new-survey,#view-results", "#view-reports")
                        .removeClass('active');
                    localStorage.setItem("last-project-survey-tab", $(this)[0].id);

                    $(this).addClass('active')

                })

        })();
    }
    paintPatientAdmissionHeading = () => {
        var healthSystemName = localStorage.getItem('healthSystemName');
        var hospitalName = localStorage.getItem('hospitalName');
        var serviceLineName = localStorage.getItem('serviceName');

        if (healthSystemName == "Select Health System" || healthSystemName == "null") {
            healthSystemName = null;
        }
        if ((hospitalName == "Select Hospital") || (hospitalName == "null")) {
            hospitalName = null;
        }
        if ((serviceLineName == "Select Service Line") || (serviceLineName == "null")) {
            serviceLineName = null;
        }

        var heading = "";
        if (healthSystemName) {
            heading = healthSystemName;
            if (hospitalName) {
                heading = hospitalName + " | " + heading;
            }
        }
        this.state.patientAdmissionHeading = heading;
        this.setState(this.state);
    }

    paintSurveyTabHeadings = () => {
        var currentPath = window.location.href;
        return currentPath.split("/").pop();
    }



    render() {

        var showSurveyTabs = this.paintSurveyTabHeadings();
        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <title> Dheeyantra | Clusters Details</title>
                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <div className="content-header"
                        >
                            <div className="container-fluid">
                                <div className="row" >
                                    <div className="col-sm-4">
                                        <h1 className="m-0 page-title" di>Surveys</h1>
                                    </div>
                                    <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                        <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>
                                            {window.SCOPE_VALUE.CURRENT == 10 ? this.state.patientAdmissionHeading : this.state.showHomeEnityName}
                                        </h1>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="container-fluid"
                        >
                            {/* Nav tabs */}
                            <div className="border-bottom"></div>
                            <div className="tab-class no-print">

                                <ul className="nav nav-tabs border-bottom navCluster">

                                    {/* <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/survey" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="new-survey" style={{ marginRight: '15px' }}>
                                        Schedule a Survey
                                    </li>
                                </Link> */}
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/survey" style={{
                                            textDecoration: 'none',
                                            display: showSurveyTabs == "survey" ? "block" : "none"
                                        }}>
                                        <li className="nav-link active" id="new-survey" style={{ marginRight: '15px' }}>
                                            Manage Surveys
                                        </li>
                                    </Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/survey/view-results" style={{
                                            textDecoration: 'none',
                                        }}>
                                        <li className={`nav-link ${showSurveyTabs == "view-results" ? "active" : ""}`} id="view-results" style={{
                                            marginRight: '15px',
                                            display: showSurveyTabs == "view-results" || showSurveyTabs == "view-reports" ?
                                                "block" : "none"
                                        }}>
                                            Individual Results
                                        </li>
                                    </Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/survey/view-reports" style={{
                                            textDecoration: 'none',
                                        }}>
                                        <li className={`nav-link ${showSurveyTabs == "view-reports" ? "active" : ""}`} id="view-reports" style={{
                                            marginRight: '15px',
                                            display: showSurveyTabs == "view-results" || showSurveyTabs == "view-reports" ? "block" : "none"
                                        }}>
                                            Results Summary
                                        </li>
                                    </Link>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>

                        <Route path="/projectmgmt/survey/view-results" component={ViewSurveyResults}></Route>
                        <Route
                            path="/projectmgmt/survey/view-patient-survey-results"
                            component={SuveryResult}
                        ></Route>
                        <Route path="/projectmgmt/survey/view-reports" component={ViewSurveyReports} ></Route>

                        <Route exact path="/projectmgmt/survey" component={ManageSurvey}></Route>

                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default SurveyTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/SurveyTabSettings.js